module.exports = __webpack_public_path__ + "img/secalot.b85fd124.svg";